import React from 'react';
import ProductPage from '../product_page/productPage';

const Likes = () => {
    return <ProductPage
        page_title={'Your Liked Items'}
        initial_filters={{}}
        likesOnly={true}
        seo={{
            title: "Your Liked Products | The Sidewalk",
            description: "View all your favorite fashion items from emerging brands."
        }}
    />;
};

export default Likes;